<template>
    <mm-select :options="adv_list" 
    v-bind="$attrs" :value="value" v-on="$listeners"/>
</template>

<script>
export default {
	data(){
		return {
			adv_list:[],
		}
	},
	props:{
		value: {
			require: true,
		},
		no_paused:Boolean,
		filter_list: {
			type: Array,
			default() { return [] }
		},
		isTracker:Boolean,
	},
	watch:{
		async filter_list(list) {
			const all_adv = await this.getAllAdv();
			this.adv_list = all_adv.filter( row => list.indexOf(row.value) === -1);
			if(this.no_paused){
				this.adv_list = this.adv_list.filter(row=>row.status!=='paused')
			}
			if (this.isTracker){
				this.adv_list = this.adv_list.filter(row=>/^\*/.test(row.name))
			}
		}
	},
	async mounted(){
		this.adv_list = await this.getAllAdv();
		if(this.no_paused){
			this.adv_list = this.adv_list.filter(row=>row.status!=='paused')
		}
		if (this.isTracker){
			this.adv_list = this.adv_list.filter(row=>/^\*/.test(row.name))
		}

	},
	methods:{
		sortAdv(x,y){
			return x['account_level'].charCodeAt() - y['account_level'].charCodeAt();
		},
		async getAllAdv() {
			if(!this.$cache['adv_list']){
				const body = await this.$post('/advertiser/list',{attributes:['adv_id','adv_name','status','account_level']});
				body.rows.sort(this.sortAdv);
				this.$cache['adv_list'] = body.rows.map(v=>{return {status:v.status,value:v['adv_id'],label:v['account_level'].toUpperCase() +':'+v['adv_name']+' ('+v['adv_id']+','+v['status']+')',name:v['adv_name'],account_level:v['account_level']}});
			}
			return this.$cache['adv_list'];
		}
	}
}
</script>